import type { Translations } from '../../types'

const sliderMessages: Translations = {
  "slider.title": "Hero slider",
  "slider.subtitle": "Aggiungi / modifica / riordina",
  "slider.form.title": "Titolo",
  "slider.form.description": "Descrizione",
  "slider.form.ctaLabel": "Testo pulsante",
  "slider.form.ctaHref": "Link pulsante",
  "slider.form.image": "URL immagine (opzionale)",
  "slider.form.saveEdit": "Salva modifica",
  "slider.form.add": "Aggiungi slide",
  "slider.form.cancelEdit": "Annulla modifica",
  "slider.actions.new": "Nuova slide",
  "slider.modal.createTitle": "Aggiungi slide",
  "slider.modal.editTitle": "Modifica slide",
  "slider.modal.subtitle": "Compila contenuti, CTA e immagine della slide hero.",
  "slider.modal.contentSection": "Contenuto slide",
  "slider.modal.contentHint": "Titolo e descrizione mostrati nell’hero.",
  "slider.modal.ctaSection": "Call to action",
  "slider.modal.ctaHint": "Collega il pulsante alla destinazione della slide.",
  "slider.modal.mediaSection": "Immagine hero",
  "slider.modal.mediaHint": "Scegli un’immagine 16:9 per mantenere il layout uniforme.",
  "slider.modal.close": "Chiudi modifica slide",
  "slider.modal.preview": "Anteprima immagine",
  "slider.modal.noImage": "Nessuna immagine",
  "slider.card.noDescription": "Nessuna descrizione",
  "slider.card.noCta": "Nessuna CTA",
  "slider.card.dragHandle": "Trascina per riordinare",
  "slider.media.previewAlt": "Anteprima slide",
  "slider.media.empty": "Carica un’immagine da PC o selezionala dalla Media Library.",
  "slider.media.helper": "Formati consigliati: JPG/PNG/WebP, proporzione 16:9.",
  "slider.media.upload": "Carica da PC",
  "slider.media.uploading": "Caricamento...",
  "slider.media.fromLibrary": "Scegli da Media Library",
  "slider.media.clear": "Rimuovi immagine",
  "slider.media.uploaded": "Immagine caricata",
  "slider.media.uploadError": "Errore upload immagine",
  "slider.media.invalidImage": "Carica un file immagine valido",
  "slider.media.loadError": "Errore caricamento media library",
  "slider.media.libraryDescription": "Seleziona una immagine dalla libreria media per questa slide.",
  "slider.list.title": "Riordina slide (drag & drop)",
  "slider.list.count": "{{count}} slide",
  "slider.list.loading": "Caricamento slide...",
  "slider.list.hintTitle": "Suggerimento immagini",
  "slider.list.hintBody": "Usa immagini 16:9 (circa 1200x675) e convertile in WebP per risparmiare spazio. Drag & drop per cambiare l’ordine.",
  "slider.list.edit": "Modifica",
  "slider.list.delete": "Elimina",
  "slider.list.empty": "Nessuna slide presente.",
  "slider.confirm.title": "Eliminare questa slide?",
  "slider.confirm.body": "La slide \"{{title}}\" verrà rimossa dalla homepage. Questa azione non è reversibile.",
  "slider.confirm.confirm": "Elimina",
  "slider.confirm.cancel": "Annulla",
  "slider.toast.apiUnavailable": "API non raggiungibile",
  "slider.toast.empty": "Nessuna slide dal backend: crea una slide e ricarica.",
  "slider.toast.loadError": "Impossibile caricare le slide: avvia gateway e cms-service.",
  "slider.toast.needTitle": "Serve un titolo per la slide.",
  "slider.toast.needLogin": "Fai login per modificare le slide.",
  "slider.toast.saveErrorPrefix": "Impossibile salvare la slide ({{status}})",
  "slider.toast.updated": "Slide aggiornata.",
  "slider.toast.created": "Slide creata.",
  "slider.toast.saveError": "Errore salvataggio slide.",
  "slider.toast.deleteError": "Errore eliminazione",
  "slider.toast.deleted": "Slide eliminata.",
  "slider.toast.reorderLogin": "Riordino locale: login per salvare.",
  "slider.toast.reorderInvalid": "ID non validi per il riordino (probabile fallback o cache vecchia). Ricarica le slide dal backend e riprova.",
  "slider.toast.reorderErrorPrefix": "Riordino non salvato ({{status}})",
  "slider.toast.reordered": "Ordine salvato sul backend.",
  "slider.toast.reorderError": "Errore riordino."
}

export default sliderMessages
